import {
  FETCH_REVIEWS,
  ADD_REVIEW,
  ADD_REPLY,
  DELETE_REVIEW,
  DELETE_REPLY,
  STORE_REVIEWS,
  RESET_REVIEWS,
  UPDATE_REVIEW,
  UPDATE_REPLY,
  UPDATED,
} from './types';

export const fetchReviews = origin => ({
  type: FETCH_REVIEWS,
  origin,
});

export const storeReviews = (reviews, origin) => ({
  type: STORE_REVIEWS,
  reviews,
  origin,
});

export const addReview = (review, origin, userInfo) => ({
  type: ADD_REVIEW,
  review,
  origin,
  userInfo,
});

export const updateReview = (review, origin) => ({
  type: UPDATE_REVIEW,
  review,
  origin,
});

export const addReply = (review, reviewId, origin) => ({
  type: ADD_REPLY,
  review,
  reviewId,
  origin,
});

export const updateReply = (review, origin) => ({
  type: UPDATE_REPLY,
  review,
  origin,
});

export const deleteReview = (reviewId, origin) => ({
  type: DELETE_REVIEW,
  reviewId,
  origin,
});

export const deleteReply = (replyId, origin) => ({
  type: DELETE_REPLY,
  replyId,
  origin,
});

export const resetReviews = () => ({
  type: RESET_REVIEWS,
});

export const hasBeenUpdated = () => ({
  type: UPDATED,
});



// WEBPACK FOOTER //
// ./src/redux/actions/reviewsActions.js